import { CampaignBlocks, } from "@kvix/shared";
import { useMediaQuery, useTheme } from "@material-ui/core";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FaQ } from "../../Other/Faq";
import { AdminFormFilePicker, AdminFormInput } from "../admin";
import { AdminCampaignContentContext } from "../context/adminCampaignContentContext";
export class FaqBlock {
    constructor() {
        this.defaultStructure = {
            name: CampaignBlocks.FaqBlock,
            titles: [""],
            media: { images: [""] },
        };
        this.Render = (props) => {
            const { block } = props;
            const theme = useTheme();
            const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
            const { t } = useTranslation("startPage");
            const questions = t("recruitLandingPage.faq.questions", {
                returnObjects: true,
            });
            return (React.createElement(FaQ, { isMobile: isMobile, title: block.titles[0], questions: questions, backgroundImage: block.media.images[0] }));
        };
        this.Compose = (props) => {
            const { block } = props;
            const { updateContent } = useContext(AdminCampaignContentContext);
            const titleOnChange = (event) => {
                block.titles[0] = event.target.value;
                updateContent(block);
            };
            const filePicker = (file) => {
                block.media.images[0] = file;
                updateContent(block);
            };
            return (React.createElement(React.Fragment, null,
                React.createElement(AdminFormInput, { name: "title", label: "Title", onChange: titleOnChange, value: block.titles[0], required: true }),
                React.createElement(AdminFormFilePicker, { name: "image", acceptedFileTypes: ["image/*"], label: "Image - recommended size: 1000x1000 px", folder: "campaign", onChange: filePicker, required: true, file: block.media.images[0] })));
        };
    }
}
//# sourceMappingURL=FaqBlock.js.map